import { useEffect, useRef } from 'react'

export function useAfterMountEffect(fn: () => void, deps: any[]) {
  const didMount = useRef(false)

  useEffect(() => {
    if (didMount.current) {
      fn()
    } else {
      didMount.current = true
    }
  }, deps)
}
